import React from "react";
import { GroupContentPanel } from "@/components/groups/GroupContentPanel";
import { EventsDirectory } from "@/pages/public/Events";
import { ResourcesDirectory } from "@/pages/public/Resources";

/**
 * Groups enhancement (GRP-DEC-317) — the Group's Events / Resources tab is the CANONICAL
 * Startup Otter directory, scoped to this Group, not a bespoke Group list:
 *
 *   • the body is `EventsDirectory` / `ResourcesDirectory` — the same components, cards,
 *     search, filters, view toggles, calendar, date logic, pagination and responsive
 *     behaviour `/events` and `/resources` render — with `groupId` set, which makes the
 *     SERVER pin the query to this Group's approved associations and the viewer's
 *     membership (no client filter can widen it);
 *   • above it, `GroupContentPanel` in `pendingOnly` mode keeps the Phase 6 association
 *     workflow: what is awaiting an organizer or an owner's consent, Approve / Decline,
 *     Remove, and the Add action.
 */
export function GroupContentDirectory({ group, kind }) {
  return (
    <div className="space-y-4" data-testid={`group-content-directory-${kind}`}>
      <GroupContentPanel group={group} kind={kind} pendingOnly />
      {kind === "event"
        ? <EventsDirectory groupId={group.id} groupName={group.display_name} />
        : <ResourcesDirectory groupId={group.id} groupName={group.display_name} />}
    </div>
  );
}
